import { render } from "./movajuste-editar.vue?vue&type=template&id=0749db14"
import script from "./movajuste-editar.vue?vue&type=script&lang=js"
export * from "./movajuste-editar.vue?vue&type=script&lang=js"

import "./movajuste-editar.vue?vue&type=style&index=0&id=0749db14&lang=css"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__